import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ActionMenuItem } from 'app/api/models/shared/actionMenuItem';
import { SharedModule } from 'app/modules/shared/shared.module';

export type GridActionMenuCellParams<T> = {
  items: (row: T) => ActionMenuItem[];
  onAction: (action: string, row: T) => void;
};

@Component({
  selector: 'app-grid-action-menu-cell',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './grid-action-menu-cell.component.html',
  styleUrl: './grid-action-menu-cell.component.scss',
})
export class GridActionMenuCellComponent<
  T,
> implements ICellRendererAngularComp {
  params!: ICellRendererParams<T> & GridActionMenuCellParams<T>;
  menuItems: ActionMenuItem[] = [];

  agInit(params: ICellRendererParams<T> & GridActionMenuCellParams<T>): void {
    this.setParams(params);
  }

  refresh(
    params: ICellRendererParams<T> & GridActionMenuCellParams<T>,
  ): boolean {
    this.setParams(params);
    return true;
  }

  onMenuAction(item: ActionMenuItem): void {
    if (this.params.data && item.action) {
      this.params.onAction(item.action, this.params.data);
    }
  }

  private setParams(
    params: ICellRendererParams<T> & GridActionMenuCellParams<T>,
  ): void {
    this.params = params;
    this.menuItems = params.data ? params.items(params.data) : [];
  }
}
